import React from 'react';
import './About.css';

export default function About() {
  return (
    <section className="about">
      <h2>About Indian Pincodes</h2>
      <h3>PincodesIndia.net</h3>
      <p>
        PincodesIndia.net provides a comprehensive directory of Indian postal codes to
        simplify location searches across the country.
      </p>

      <h4>Our Mission</h4>
      <p>
        The platform delivers accurate, up-to-date PIN code information for all 29 states
        and 8 union territories, helping users find post offices, villages, and cities
        effortlessly. Launched to address the challenges of India's vast postal network,
        it covers over 1.5 lakh post offices with details like delivery status and contact
        info.
      </p>

      <h4>Why We Started</h4>
      <p>
        Finding precise PIN codes was often frustrating amid scattered government data
        and outdated directories. Our team of developers and data experts compiled
        verified India Post records into a user-friendly search tool, prioritizing mobile
        access for everyday needs like e-commerce deliveries and address verification.
      </p>
    </section>
  );
}
